export default __webpack_public_path__ + "static/media/Gilroy-SemiBold.07b9100a.ttf";